export const cssVariablesLight = {
  "--tg-theme-hint-color": "#999999",
  "--tg-theme-secondary-bg-color": "#efeff3",
  "--tg-theme-text-color": "#000000",
  "--tg-theme-section-bg-color": "#ffffff",
  "--tg-theme-header-bg-color": "#efeff3",
  "--tg-theme-accent-text-color": "#2481cc",
  "--tg-color-scheme": "light",
  "--tg-viewport-height": "100vh",
  "--tg-theme-destructive-text-color": "#ff3b30",
  "--tg-theme-button-color": "#2481cc",
  "--tg-theme-bg-color": "#ffffff",
  "--tg-theme-subtitle-text-color": "#999999",
  "--tg-theme-button-text-color": "#ffffff",
  "--tg-theme-section-header-text-color": "#6d6d71",
  "--tg-theme-link-color": "#2481cc",
  "--tg-viewport-stable-height": "100vh",
};

export const cssVariablesDark = {
  "--tg-theme-hint-color": "#b1c3d5",
  "--tg-theme-secondary-bg-color": "#131415",
  "--tg-theme-text-color": "#ffffff",
  "--tg-theme-section-bg-color": "#18222d",
  "--tg-theme-header-bg-color": "#131415",
  "--tg-theme-accent-text-color": "#2ea6ff",
  "--tg-color-scheme": "dark",
  "--tg-viewport-height": "100vh",
  "--tg-theme-destructive-text-color": "#ef5b5b",
  "--tg-theme-button-color": "#2ea6ff",
  "--tg-theme-bg-color": "#18222d",
  "--tg-theme-subtitle-text-color": "#b1c3d5",
  "--tg-theme-button-text-color": "#ffffff",
  "--tg-theme-section-header-text-color": "#b1c3d5",
  "--tg-theme-link-color": "#62bcf9",
  "--tg-viewport-stable-height": "100vh",
};
